import { createContext, useContext, useMemo } from 'react';
import { EQ_FREQUENCIES } from '../constants/frequencies';

const defaultConfig = {
  eqFrequencies: EQ_FREQUENCIES,
  isFrequencyPlayable: () => true,
  isFrequencyInteractable: () => true,
  canEditScenario: true,
};

const FeatureConfigContext = createContext(defaultConfig);

export function FeatureConfigProvider({ value, children }) {
  const normalizedValue = useMemo(() => {
    const eqFrequencies = value?.eqFrequencies || EQ_FREQUENCIES;
    const isFrequencyPlayable = value?.isFrequencyPlayable || defaultConfig.isFrequencyPlayable;
    const isFrequencyInteractable =
      value?.isFrequencyInteractable || defaultConfig.isFrequencyInteractable;

    return {
      ...defaultConfig,
      ...value,
      eqFrequencies,
      isFrequencyPlayable,
      isFrequencyInteractable,
    };
  }, [value]);

  return (
    <FeatureConfigContext.Provider value={normalizedValue}>
      {children}
    </FeatureConfigContext.Provider>
  );
}

export function useFeatureConfig() {
  const context = useContext(FeatureConfigContext);
  if (context === undefined || context === null) {
    throw new Error('useFeatureConfig must be used within a FeatureConfigProvider');
  }
  return context;
}

export default FeatureConfigContext;


